<template>
  <q-dialog class="theme-1" v-model="show" @hide="onClose" position="top">
    <div class="card bg-white mt-4">
      <div class="card-body text-center">
        <span class="font-size-14 d-block" v-html="dialogDeleteState?.message"></span>
        <span class="font-size-14 d-block"> {{ dialogDeleteState?.payload?.rowIndex }}</span>
        <div v-if="requiresTextConfirmation" class="mt-3">
          <span
            class="font-size-13 d-block mb-2"
            v-html="$t('main.confirmationDeleteDialog.typeToConfirm', { text: expectedConfirmationText })"
          ></span>
          <q-input
            v-model="confirmationValue"
            dense
            outlined
            autofocus
            :placeholder="expectedConfirmationText"
          />
        </div>
      </div>

      <div class="card-footer d-flex justify-content-end">

        <q-btn class="btn text-body mr-2" color="transparent" :label="$t('main.confirmationDeleteDialog.cancelButton')"
          @click="onCancel" />
        <q-btn class="btn btn-primary" :label="$t('main.confirmationDeleteDialog.confirmationButton')"
          :disable="requiresTextConfirmation && !isConfirmationValueValid"
          @click="onConfirm" />
      </div>

    </div>

  </q-dialog>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit } from "vue-property-decorator";
import store from "@/store";
import router from "@/router";

@Options({
  props: {
    show: Boolean
  }
})
export default class ConfirmationDeleteDialog extends Vue {

  name = 'confirmation-delete'
  show?: boolean;
  confirmationValue = "";

  get dialogDeleteState() {
    return store.state.confirmationDeleteDialogState
  }

  get requiresTextConfirmation() {
    return !!this.dialogDeleteState?.requireTextConfirmation;
  }

  get expectedConfirmationText() {
    return (this.dialogDeleteState?.confirmationText || "supprimer").toString();
  }

  get isConfirmationValueValid() {
    return this.confirmationValue?.trim().toLowerCase() === this.expectedConfirmationText.toLowerCase();
  }

  @Emit("onConfirm")
  onConfirm() {
      const dialogState = this.dialogDeleteState;
      if (!dialogState) return; 
      if (this.requiresTextConfirmation && !this.isConfirmationValueValid) return;
      const {callback}  = dialogState;
    const target = this.dialogDeleteState?.target || ''
      console.log('executeDeleteConfirmation' + this.dialogDeleteState?.deleteAction)
      store.dispatch('executeDeleteConfirmation' + this.dialogDeleteState?.deleteAction, this.dialogDeleteState?.payload).then(() => {
        router.push(target)
      if (callback && typeof callback === 'function') {
        callback();
      }
      this.confirmationValue = "";
      })
  }

  @Emit("onCancel")
  onCancel() {
    this.confirmationValue = "";
    store.dispatch('hideConfirmationDeleteDialog')
  }

  @Emit("onClose")
  onClose() {
    this.confirmationValue = "";
    store.dispatch('hideConfirmationDeleteDialog')
  }

}
</script>

<style scoped>
button {
  border-radius: 10px;
}
</style>